import PropTypes from 'prop-types'
import { LOADING_ACTIONS } from '../actions/types'

/**
 * @typedef {object} LoadingState
 * @property {boolean} liac
 * @property {boolean} bulkTags
 * @property {boolean} bulkPrint
 * @property {boolean} session
 * @property {boolean} admin
 */

export const loadingPropTypes = PropTypes.shape({
  liac: PropTypes.bool,
  bulkTags: PropTypes.bool,
  bulkPrint: PropTypes.bool,
  session: PropTypes.bool,
  admin: PropTypes.bool
})

/**
 * initial state for loading slice
 * @type {LoadingState}
 */
const initialState = {
  liac: false,
  bulkTags: false,
  bulkPrint: false,
  session: true,
  admin: true
}

/**
 * reducer to manage various loading states.
 *
 * @param {LoadingState} state
 * @param {{ type: string, payload: Partial<LoadingState> }} action
 *
 * @returns {LoadingState}
 */
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADING_ACTIONS.SET:
      return {
        ...state,
        // prevents setting a loading state unless payload value is different from state value
        ...Object.fromEntries(Object.entries(payload || {}).filter(([k, v]) => state[k] !== v))
      }
    default:
      return state
  }
}
